module.exports = __webpack_public_path__ + "static/media/escrever-highlight-sp.fc859217.svg";